'use strict';

// dom
const {
	h1, a, div, header, p,
	section, button, span, ul, li
} = require('iblokz-snabbdom-helpers');
// components
const form = require('../../../comp/form');

// lib
const {obj} = require('iblokz-data');
const _rl = require('../../../../util/resolve-localized');
const {normalizeDocI18nFields} = _rl.default || _rl;
const eventTime = require('../../../../util/event-time');

const excludeFields = [
	'createdBy', 'createdOn'
];

// Keep multipart upload handles for resource.save → FormData (avatar/poster).
const uploadMetaKeys = {
	_avatarFile: true,
	_avatarFileName: true,
	_avatarKind: true,
	_posterFile: true,
	_posterFileName: true,
	_posterKind: true
};

// Strip UI-only / mongoose internals — keep `_id` so save updates instead of creates
const ephemeralKeys = key =>
	key === 'fieldLang'
	|| key === '__v'
	|| (key.charAt(0) === '_' && key !== '_id' && !uploadMetaKeys[key]);

module.exports = ({state, actions, i18n}) => {
	const collection = state.router.path[1];
	const colMeta = state.rest.collections[collection] || {};
	const schema = colMeta.schema || {};
	const i18nFields = colMeta.i18n || [];
	const fieldLangs = (state[collection] && state[collection].fieldLang) || {};

	return form({
		sel: state.router.pageId === 'new' ? '.create' : '.edit',
		schema: obj.filter(
			schema,
			(field, value) => excludeFields.indexOf(field) === -1
		),
		doc: state[collection].doc,
		focused: state[collection].focused || false,
		state,
		i18n,
		i18nFields,
		fieldLangs,
		setFieldLang: (fieldName, loc) => actions.set(
			[collection, 'fieldLang', fieldName],
			{lang: loc, base: state.lang || 'bg'}
		),
		fullActions: actions,
		actions: {
			update: (field, value) => actions.set(
				[collection, 'doc'],
				doc => obj.patch(doc || {}, field, value)
			),
			save: ({data, ev}) => {
				const merged = Object.assign({}, state[collection].doc, data);
				const cleaned = obj.filter(
					obj.map(
						merged,
						(key, value) => {
							if (ephemeralKeys(key)) return undefined;
							if (i18nFields.indexOf(key) > -1) {
								// prefer doc (locale map) over form string snapshot
								return state[collection].doc[key];
							}
							if (['content', 'article', 'post', 'text', 'about'].indexOf(key) > -1
								&& value && value.content !== undefined) {
								return value.content;
							}
							const schemaField = schema[key];
							if (schemaField instanceof Array && typeof value === 'string') {
								return value.split(',').map(s => s.trim()).filter(Boolean);
							}
							if (schemaField && schemaField.type === 'ObjectId'
								&& (value === '' || value === undefined || value === null)) {
								return undefined;
							}
							// Event start/end: wall clock in doc.timezone → real UTC
							if ((key === 'startDateTime' || key === 'endDateTime')
								&& (schemaField === 'Date' || (schemaField && schemaField.type === 'Date'))) {
								return eventTime.fromInputValue(
									value,
									merged.timezone || eventTime.DEFAULT_TZ
								);
							}
							return value;
						}
					),
					(key, value) => value !== undefined
				);
				const payload = normalizeDocI18nFields(cleaned, i18nFields);
				actions[collection].save(
					payload,
					state.auth.token,
					() => actions.router.go(state.router.path.slice(0, 2).join('.'))
				);
			},
			cancel: ({ev}) => actions.router.go(state.router.path.slice(0, 2).join('.'))
		}
	});
};
